import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurfacePolyIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M4 17 8 6l12-2-2 16z",
			opacity: .12
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4 17 8 6l12-2-2 16z" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4,
			cy: 17,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 6,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 4,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 20,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgSurfacePolyIcon;
